import { render, staticRenderFns } from "./LimpioLayout.vue?vue&type=template&id=1de8f9a3&"
import script from "./LimpioLayout.vue?vue&type=script&lang=js&"
export * from "./LimpioLayout.vue?vue&type=script&lang=js&"
import style0 from "./LimpioLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports